export default function generateH2Id(h2Element: HTMLHeadingElement): string {
  if (h2Element.tagName.toLowerCase() !== 'h2' || !h2Element.textContent) {
    throw new Error('Element must be an H2 with text content');
  }

  const baseId = h2Element.textContent
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-') // Replace non-alphanumeric characters with dashes
    .replace(/(^-+)|(-+$)/g, '') // Trim leading/trailing dashes with explicit grouping
    .slice(0, 50); // Limit to 50 characters

  let uniqueId = baseId;
  let counter = 1;
  const existingIds = new Set(Array.from(document.querySelectorAll('h2[id]'), el => el.id));

  while (existingIds.has(uniqueId)) {
    uniqueId = `${baseId}-${counter++}`.slice(0, 50);
  }

  h2Element.id = uniqueId;

  return uniqueId;
}
